module.exports = "/_next/static/images/b425dea1ca5df78087311fd1eb79b748-aboutus-ed.jpg";